import {
  PublicBootstrapResponseSchema,
  type PublicBootstrapConfig,
} from '@cnapse/shared/bootstrap.schema.js';
import { resolveBootstrapApiBaseUrl } from '../config/bootstrap-api-url.js';
import { configureApiEndpoints } from '../config/api-endpoints.js';
import { setBootstrapConfig } from '../config/bootstrap-state.js';
import { applyBootstrapToEnvironment } from '../config/environment.js';
import { configureAmplify } from '../config/amplify.config.js';
import { applyBootstrapRealtimeSettings } from '../config/realtime.js';
import { setEfemLockTimeoutSeconds } from '../config/efem-lock-config.js';

export async function fetchPublicBootstrap(): Promise<PublicBootstrapConfig> {
  const apiBaseUrl = resolveBootstrapApiBaseUrl();
  const response = await fetch(`${apiBaseUrl}/api/public/bootstrap`);

  if (!response.ok) {
    throw new Error(`Bootstrap request failed (${response.status} ${response.statusText})`);
  }

  const json: unknown = await response.json();
  const parsed = PublicBootstrapResponseSchema.parse(json);
  return parsed.data;
}

export function applyPublicBootstrap(config: PublicBootstrapConfig): void {
  setBootstrapConfig(config);
  configureApiEndpoints({
    apiBaseUrl: config.apiBaseUrl,
    locationApiBaseUrl: config.locationApiBaseUrl,
  });
  applyBootstrapToEnvironment(config);
  configureAmplify({
    userPoolId: config.cognitoUserPoolId,
    userPoolClientId: config.cognitoClientId,
  });
  applyBootstrapRealtimeSettings(config.realtimeSseEnabled);
  setEfemLockTimeoutSeconds(config.efemLockTimeoutSeconds);
}

export async function loadAndApplyPublicBootstrap(): Promise<PublicBootstrapConfig> {
  const config = await fetchPublicBootstrap();
  applyPublicBootstrap(config);
  return config;
}
